import type { Skin } from 'c-entity-types';
import { baseInitialState, createBaseSlice } from 'c-data';
import { createByIdNetworkRequestsActions } from 'c-lib';
import type { SkinState } from './Skin-types';

const initialState: SkinState = {
    ...baseInitialState,
    uploadingLargeLogoById: {},
    uploadingSmallLogoById: {},
    uploadingLargeDarkLogoById: {},
    uploadingSmallDarkLogoById: {},
    attachingSkinById: {},
};

const additionalReducers = {
    // example: (state: SkinState, action: PayloadAction<string>): SkinState => state,
    ...createByIdNetworkRequestsActions<SkinState>()<
        'uploadingLargeLogoById',
        'UploadingLargeLogo'
    >('uploadingLargeLogoById', 'UploadingLargeLogo'),
    ...createByIdNetworkRequestsActions<SkinState>()<
        'uploadingSmallLogoById',
        'UploadingSmallLogo'
    >('uploadingSmallLogoById', 'UploadingSmallLogo'),
    ...createByIdNetworkRequestsActions<SkinState>()<
        'uploadingLargeDarkLogoById',
        'UploadingLargeDarkLogo'
    >('uploadingLargeDarkLogoById', 'UploadingLargeDarkLogo'),
    ...createByIdNetworkRequestsActions<SkinState>()<
        'uploadingSmallDarkLogoById',
        'UploadingSmallDarkLogo'
    >('uploadingSmallDarkLogoById', 'UploadingSmallDarkLogo'),
    ...createByIdNetworkRequestsActions<SkinState>()<'attachingSkinById', 'AttachingSkin'>(
        'attachingSkinById',
        'AttachingSkin',
    ),
};

const slice = createBaseSlice<Skin, SkinState, typeof additionalReducers>({
    name: 'skin',
    entityName: 'Skin',
    initialState,
    reducers: additionalReducers,
});

const skinSlice = {
    skinActions: slice.slice.actions,
    skinReducer: slice.slice.reducer,
    skinAdapter: slice.adapter,
    skinSelectors: slice.selectors,
    skinThunks: slice.thunks,
};

export const { skinReducer, skinActions, skinAdapter, skinSelectors, skinThunks } = skinSlice;
